<template>
  <div>
    <div class="table-header mt-16">
      <div class="flex items-center">
        <!-- <div class="mr-2 filter">
          <svg
            width="12"
            height="18"
            viewBox="0 0 12 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.9841 1.99255C6.9841 1.44027 7.43181 0.992554 7.9841 0.992554C8.34149 0.992554 8.65509 1.18004 8.83192 1.46202L11.5195 4.14964C11.9101 4.54016 11.9101 5.17333 11.5195 5.56385C11.129 5.95438 10.4958 5.95438 10.1053 5.56385L8.9841 4.44263V11.9926C8.9841 12.5448 8.53638 12.9926 7.9841 12.9926C7.43181 12.9926 6.9841 12.5448 6.9841 11.9926V2.042C6.98397 2.03288 6.98397 2.02376 6.9841 2.01464V1.99255Z"
              fill="#10233E"
            />
            <path
              d="M5.01589 16.0074C5.01589 16.5597 4.56818 17.0074 4.01589 17.0074C3.6585 17.0074 3.3449 16.82 3.16807 16.538L0.480454 13.8504C0.08993 13.4598 0.08993 12.8267 0.480454 12.4361C0.870978 12.0456 1.50414 12.0456 1.89467 12.4361L3.01589 13.5574V6.00745C3.01589 5.45516 3.46361 5.00745 4.01589 5.00745C4.56818 5.00745 5.01589 5.45516 5.01589 6.00745V15.958C5.01602 15.9671 5.01602 15.9762 5.01589 15.9854V16.0074Z"
              fill="#10233E"
            />
          </svg>
        </div> -->
        <div class="table__search-input-wrapper">
          <span class="pr-2 opacity-50">
            <search-icon />
          </span>

          <input type="text" class="table__search-input" placeholder="Search..." v-model="queryString" />

          <img src="@/assets/images/icons/search.svg" alt="search icon" />
        </div>
      </div>

      <div class="date-picker flex items-center justify-center">
        <bulk-action class="mr-8" :display="isBulkAction">
          <p class="pb-2" @click="isLoyaltyGroupModal = true">Add to loyalty</p>
          <p class="pb-2" @click="isBlacklistContactModal = true">Blacklist</p>
          <p class="pb-2 hidden" @click="scheduleMeeting">Schedule a meeting</p>
        </bulk-action>
        <div class="relative" tabindex="-1">
          <div class="rounded create-button py-2 flex justify-center items-center cursor-pointer"
            @click="$router.push({ name: 'BlacklistedContacts' })">
            <p>Blacklisted</p>
          </div>
        </div>
        <div>
          <button class="border-2 border-darkBlue rounded py-1 px-3 font-semibold ml-4" @click="isExportModal = true">
            Export Register
          </button>
        </div>
      </div>
    </div>

    <div class="table-wrapper" id="table-wrapper">
      <table class="custom-table responsive-table">
        <thead>
          <tr>
            <th>
              <base-checkbox v-model="selectAll" />
            </th>
            <th>CUSTOMER NAME</th>
            <th>PROFILE NAME</th>
            <th>MULEEX ID</th>
            <th>BILLING ADDRESS</th>
            <th>CONTACT PERSON</th>
            <th>REGISTERED BY</th>
            <th>REG. CHANNEL</th>
            <th class="relative" tabindex="-1">
              <span class="cursor-pointer">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g opacity="0.7">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                      fill="#383F51" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                      fill="#383F51" />
                  </g>
                </svg></span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="contact in filteredContacts" :key="contact.id" class="cursor-pointer">
            <!-- @click="viewContactProfile(contact.id)" -->
            <td>
              <base-checkbox :value="contact.id" v-model="selectedContacts" />
            </td>
            <td @click="viewContactProfile(contact.id)">{{ contact.name }}</td>
            <td>On-Demand</td>
            <td>{{ contact.code }}</td>
            <td>{{ contact.address }}</td>
            <td>
              {{ contact.contactPerson ? contact.contactPerson : contact.name }}
            </td>
            <td>Self</td>
            <td>MuleEx</td>
            <td class="relative" tabindex="-1" @blur="selectedRowId = null">
              <span @click="
                selectedRowId
                  ? (selectedRowId = null)
                  : (selectedRowId = contact.id)
              ">
                <vertical-ellipsis />
              </span>
              <action-popup width="w-48" v-if="selectedRowId == contact.id">
                <div>
                  <p class="py-1" @click="
                    (selectedContact = contact),
                    (isBlacklistContactModal = true)
                  ">
                    Blacklist this Contact
                  </p>
                  <p class="py-1" @click="
                    (selectedContact = contact), (isLoyaltyGroupModal = true)
                  ">
                    Add to Loyalty Scheme
                  </p>
                  <!-- <p class="py-1">
                    Messaging
                  </p>
                  <p class="py-1" @click="scheduleMeeting(contact.id)">
                    Schedule a Meeting
                  </p> -->
                </div>
              </action-popup>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="!contacts.length && !loading" class="bg-white w-100 flex justify-center flex-col items-center p-5">
      <empty-table-icon />
      <p class="font-semibold pt-3">
        Looks like you have not registered anyone yet.!
      </p>
      <p class="text-sm py-3">
        Add a new customer manually or import their details with the options
        below.
      </p>
      <div class="flex justify-between  pb-5">
        <p class="cursor-pointer text-primary-blue" @click="$router.push({ name: 'CustomerRegistration' })">
          Create New
        </p>
        <p class="cursor-pointer pl-12 text-primary-blue" @click="$router.push({ name: 'ImportContacts' })">
          Import Customer Details
        </p>
      </div>
    </div>
    <loader v-if="loading" />
    <pagination-control />

    <!-- Modal -->
    <loyalty-group-modal :show-modal="isLoyaltyGroupModal" @close-modal="isLoyaltyGroupModal = false"
      :contact="selectedContact" :contactIds="selectedContacts" />
    <blacklist-contact-modal v-if="isBlacklistContactModal" :show-modal="isBlacklistContactModal"
      @close-modal="isBlacklistContactModal = false" @contact-blacklisted="getAllContacts(), $emit('update')"
      :contact="selectedContact" :contactIds="selectedContacts" />
    <!-- <customer-id-modal
      :show-modal="isCustomerIdModal"
      @close-modal="isCustomerIdModal = false"
    /> -->
    <loyalty-scheme-modal :show-modal="isLoyaltySchemeModal" @close-modal="isLoyaltySchemeModal = false" />
    <export-modal :show-modal="isExportModal" @close-modal="isExportModal = false" />

    <!-- Modal -->
  </div>
</template>

<script>
import PaginationControl from "@/components/UI/NewPagination";
import LoyaltyGroupModal from "../CustomerRegistration/Modals/AddToLoyaltyGroup";
import BlacklistContactModal from "../CustomerRegistration/Modals/BlacklistContact";
import LoyaltySchemeModal from "../CustomerRegistration/Modals/CreateLoyaltyScheme";
import ExportModal from "../Modals/ExportContacts.vue";

import FileDownload from "js-file-download";

export default {
  components: {
    PaginationControl,
    LoyaltyGroupModal,
    BlacklistContactModal,
    LoyaltySchemeModal,
    ExportModal,
  },
  data() {
    return {
      contacts: [],
      showCreateOptions: false,
      loading: true,
      isLoyaltyGroupModal: false,
      isBlacklistContactModal: false,
      isCustomerIdModal: false,
      isLoyaltySchemeModal: false,
      selectedRowId: null,
      selectedContact: {},
      queryString: "",
      selectAll: false,
      selectedContacts: [],
      isExportModal: false,
      isUploadingImage: false,
    };
  },
  computed: {
    filteredContacts() {
      return this.filterArray(this.contacts, this.queryString);
    },
    isBulkAction() {
      return this.selectedContacts.length ? true : false;
    },
  },
  watch: {
    selectAll(val) {
      if (val) {
        this.contacts.forEach((contact) => {
          this.selectedContacts.push(contact.id);
        });
      } else {
        this.selectedContacts = [];
      }
    },
  },
  mounted() {
    this.getAllContacts();
  },
  methods: {
    async getAllContacts() {
      this.loading = true;
      try {
        const response = await this.$_getAllContacts();
        console.log(response);
        this.contacts = response.data.contacts;
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    scheduleMeeting(contactId = null) {
      if (contactId) {
        this.selectedContacts.push(contactId);
      }
      localStorage.setItem(
        "contactIds",
        JSON.stringify(this.selectedContacts)
      );
      this.$router.push("/crm/meetings/new?contacts=true");
    },
    viewContactProfile(contactId) {
      localStorage.setItem("customerId", contactId);
      this.$router.push({ name: "CustomerProfile" });
    },
    async exportContacts() {
      try {
        const response = await this.$_downloadContact();
        console.log(response);
        FileDownload(response.data, "contacts.csv");
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.table__search-input-wrapper {
  background: #f7fafd;
  width: 20rem;
  border-radius: 5px;
}

.custom-table,
.table-wrapper {
  margin-bottom: 0;
}

th {
  color: #707684;
  font-size: 0.8rem;
  padding: 0.5rem;
}

td {
  background: #ffffff;
  color: var(--primaryblue);
  font-weight: 500;
  border-radius: 2px;
  padding: 1rem 0.5rem;
  vertical-align: top;

  span {
    display: block;
  }

  span:last-of-type {
    font-weight: normal;
    color: #10233e;
    opacity: 0.6;
    padding-top: 0.25rem;
    font-size: 0.8rem;
  }
}

.checkbox {
  display: initial;
  width: 1rem;
  height: 1rem;
}

table {
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}

.create-options {
  position: absolute;
  cursor: pointer;
  top: 3rem;
  width: 10rem;
  background: #ffffff;
  font-size: 0.9rem;
  padding: 0.25rem;
}

.create-button {
  width: 10rem;
  background: #10233e;
  color: #ffffff;
  text-align: center;
}
</style>
